// Users who always get pro access (for testing/debugging)
const DEBUG_PRO_EMAILS = ["dstaudigel@gmail.com"];

export function isSubscriber(): Ref<boolean> {
  const profile = usePublicProfile();
  const user = useSupabaseUser();

  return computed(() => {
    // Debug users always get pro
    if (DEBUG_PRO_EMAILS.includes(user.value?.email ?? "")) return true;

    return profile.value?.pro_until
      ? new Date(profile.value?.pro_until).getTime() > Date.now()
      : false;
  });
}
